import React, { useEffect, useState, useContext } from "react";
import "tailwindcss/tailwind.css";
import LoginForm from "./LoginForm";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { LoginContext } from "../../Context/Auth";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import loginBg from "../../Assets/marketing.jpg"; // Use any image from your Assets folder

const Login = () => {   
  const navigate = useNavigate();
  const { loginResponse, loginError, isLoading, login, resetLoginState } =
    useContext(LoginContext);
  const [dynamicImages, setDynamicImages] = useState(["time"]);

  useEffect(() => {
    if (loginResponse) {
      if (loginResponse.message) {
        toast.error("Your password is expired, please reset your password");
        resetLoginState();
      } else {
        toast.success("Login successful");
        navigate("/dashboard"); // Redirect to dashboard
      }
    }
  }, [loginResponse]);

  useEffect(() => {
    if (loginError && !isLoading) {
      toast.error(loginError.message);
      resetLoginState();
    }
  }, [loginError]);

  const settings = {
    dots: false,
    fade: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    waitForAnimate: false,
  };

  return (
    <div className="flex min-h-screen">
      {/* Left: Image section, hidden on small screens */}
      <div className="hidden sm:flex w-8/12 h-screen items-center justify-center bg-[#e4e9f0]">
        <img
          src={loginBg}
          alt="Login Visual"
          className="object-cover w-full h-full shadow-xl" // removed rounded-r-3xl
        />
      </div>
      {/* Right: Login form */}
      <div className="mt-10 w-full sm:w-4/12 flex items-start justify-center p-6 bg-white">
        <LoginForm onLogin={login} />
      </div>
    </div>
  );
};

export default Login;
